export default __webpack_public_path__ + "static/media/MichaelElliEric400.6f5b53c4.jpg";